export var SectionType;
(function (SectionType) {
    SectionType["UNKNOWN"] = "UNKNOWN";
    /** only page placement support */
    SectionType["TAG"] = "TAG";
    /** only page placement support */
    SectionType["BANNER"] = "BANNER";
    /** only page placement support */
    SectionType["TAGLIST"] = "TAGLIST";
    /** only side bar placement support */
    SectionType["SIDEBAR"] = "SIDEBAR";
    /** only app benefits placement support */
    SectionType["APP"] = "APP";
})(SectionType || (SectionType = {}));
export var SortMethod;
(function (SortMethod) {
    SortMethod["NO_SORT"] = "NO_SORT";
    SortMethod["INSTALLS"] = "INSTALLS";
    SortMethod["GEO"] = "GEO";
    SortMethod["REVIEWS_RATING"] = "REVIEWS_RATING";
    SortMethod["APP_MARKET_SCORE"] = "APP_MARKET_SCORE";
    SortMethod["ML_MODEL_RANKING"] = "ML_MODEL_RANKING";
    SortMethod["MANUAL"] = "MANUAL";
    SortMethod["DEALER"] = "DEALER";
})(SortMethod || (SortMethod = {}));
export var TagSectionType;
(function (TagSectionType) {
    TagSectionType["UNKNOWN"] = "UNKNOWN";
    TagSectionType["COLLECTION"] = "COLLECTION";
    TagSectionType["PROMO"] = "PROMO";
})(TagSectionType || (TagSectionType = {}));
export var BannerType;
(function (BannerType) {
    BannerType["UNKNOWN"] = "UNKNOWN";
    BannerType["DEVCENTER"] = "DEVCENTER";
    BannerType["CREATEWEBSITE"] = "CREATEWEBSITE";
})(BannerType || (BannerType = {}));
export var SectionsPlacement;
(function (SectionsPlacement) {
    SectionsPlacement["UNKNOWN"] = "UNKNOWN";
    /** Represents a placement which can return the following sections types: TAG, BANNER, TAGLIST */
    SectionsPlacement["PAGE"] = "PAGE";
    /** Represents a placement which can return the following sections types: SIDEBAR */
    SectionsPlacement["SIDE_BAR"] = "SIDE_BAR";
    /** Represents a placement which can return the following sections types: APP */
    SectionsPlacement["APP_BENEFITS"] = "APP_BENEFITS";
})(SectionsPlacement || (SectionsPlacement = {}));
//# sourceMappingURL=types.impl.js.map